type Props = {
  message: string;
};

export default function ChatErrorMessage(props: Props) {
  const { message } = props;
  return <div className="mb-4 text-xs text-red-500">{message}</div>;
}
